// components/StockTables/BalanceStockTable.jsx
import React from 'react';
import _ from 'lodash'; // ตรวจสอบให้แน่ใจว่ามีการ import lodash

const BalanceStockTable = ({ data }) => {
  // 1. ปรับปรุงการสร้าง Map ข้อมูลซื้อ-ขายให้ตรงกับ Schema ใหม่
  //    - ใช้ data.filterBuy.materials และ data.filterSale.materials
  //    - เปลี่ยน key จาก 'material' เป็น 'product' เพื่อให้ map กับ item.id ได้
  const buyDataMap = _.keyBy(data?.filterBuy?.materials, 'product');
  const sellDataMap = _.keyBy(data?.filterSale?.materials, 'product');
  const [totalProfitNew, setTotalProfitNew] = React.useState(0);
  const [totalProfitOld, setTotalProfitOld] = React.useState(0);
  const [totalProfitOther, setTotalProfitOther] = React.useState(0);

  React.useEffect(() => {
    const calculateProfits = () => {
      let newProfit = 0;
      let oldProfit = 0;
      let otherProfit = 0;

      _.forEach(data?.material?.rows, (item) => {
        const sellData = sellDataMap[item.id];
        const isGoldBar =
          item?.isbar || ['ทองคำแท่ง', 'ทองแท่ง'].includes(item?.name);
        const placeName = item?.place?.name;
        const isOtherPlace = placeName === 'คลังอื่นๆ';

        let multiplier;
        if (isOtherPlace) {
          multiplier = 1;
        } else if (isGoldBar) {
          multiplier = 15.244;
        } else {
          multiplier = 15.16;
        }

        const totalWeight = (item?.weight || 0) + (sellData?.totalWeight || 0);
        const totalCost = (item?.cost || 0) + (sellData?.totalValue || 0);

        const averageValue =
          totalWeight > 0 ? (totalCost / totalWeight) * multiplier : 0;

        const avgValue2f = Number(averageValue.toFixed(2));
        const averageProfit =
          (sellData?.totalValue || 0) -
          (avgValue2f / multiplier) * (sellData?.totalWeight || 0);

        const profitToAdd = isNaN(averageProfit) ? 0 : averageProfit;

        if (placeName === 'คลังรูปพรรณใหม่') {
          newProfit += profitToAdd;
        } else if (placeName === 'คลังรูปพรรณเก่า') {
          oldProfit += profitToAdd;
        } else if (placeName === 'คลังอื่นๆ') {
          otherProfit += profitToAdd;
        }
      });

      setTotalProfitNew(newProfit);
      setTotalProfitOld(oldProfit);
      setTotalProfitOther(otherProfit);
    };

    calculateProfits();
  }, [data, sellDataMap]);
  //console.log('data in BalanceStockTable', data?.material?.rows);

  const TableHeader = (place) => (
    <thead className="bg-yellow-400">
      <tr>
        <th className="px-4 py-3 text-left text-sm font-bold text-gray-800 border-r border-gray-300">
          รายการสินค้า
        </th>
        <th className="px-4 py-3 text-center text-sm font-bold text-gray-800 border-r border-gray-300">
          ประเภท
        </th>
        {place.place !== 'คลังอื่นๆ' ? (
          <th className="px-4 py-3 text-center text-sm font-bold text-gray-800 border-r border-gray-300">
            น้ำหนักคงเหลือ
          </th>
        ) : (
          <th className="px-4 py-3 text-center text-sm font-bold text-gray-800 border-r border-gray-300">
            จำนวนคงเหลือ
          </th>
        )}
        <th className="px-4 py-3 text-center text-sm font-bold text-gray-800 border-r border-gray-300">
          {place.place === 'คลังอื่นๆ' ? 'มูลค่าเฉลี่ย' : 'มูลค่าเฉลี่ยต่อบาท'}
        </th>
        <th className="px-4 py-3 text-center text-sm font-bold text-gray-800">
          กำไรขั้นต้น
        </th>
      </tr>
    </thead>
  );

  const TableRows = ({ materials }) => (
    <tbody>
      {materials.length > 0 ? (
        _.map(materials, (item, index) => {
          // การดึงข้อมูลยังคงใช้ item.id ซึ่งตอนนี้จะตรงกับ key 'product' ใน Map
          const buyData = buyDataMap[item.id];
          //console.log('materials', materials);

          // console.log('Buy Data:', buyData);
          // console.log('material item:', item);

          const sellData = sellDataMap[item.id];
          // console.log('Sell Data:', sellData);
          // 2. ปรับการเช็ค 'isbar' ให้ใช้ข้อมูลจาก `item` โดยตรงเพื่อความแม่นยำ
          const isGoldBar =
            item?.isbar || ['ทองคำแท่ง', 'ทองแท่ง'].includes(item?.name);

          // `buyData.place` เป็น string ใน schema ใหม่อยู่แล้ว ส่วนนี้ยังใช้ได้
          const isOtherPlace = item?.place?.name === 'คลังอื่นๆ';

          let multiplier;
          if (isOtherPlace) {
            multiplier = 1;
          } else if (isGoldBar) {
            multiplier = 15.244;
          } else {
            multiplier = 15.16;
          }
          const sumtotal = (sellData?.totalValue || 0) - (item?.cost || 0);

          // 3. อัปเดตฟิลด์จาก totalCost เป็น totalValue ในการคำนวณ
          const averageValue =
            sellData?.totalWeight || item?.weight > 0
              ? ((item?.cost + (sellData?.totalValue || 0)) /
                  (item?.weight + (sellData?.totalWeight || 0))) *
                multiplier
              : 0;

          const avgValue2f = Number(averageValue.toFixed(2));
          const avgCost = avgValue2f * sellData?.totalWeight;
          //คำนวณกำไรขั้นต้น
          const averageProfit =
            sellData?.totalValue -
            (avgValue2f / multiplier) * sellData?.totalWeight;

          return (
            <tr
              key={index}
              className="bg-white border-b border-gray-200 hover:bg-gray-50"
            >
              <td className="px-4 py-2 text-sm text-gray-800 border-r border-gray-200">
                {item.name || '-'}
              </td>
              <td className="px-4 py-2 text-sm text-gray-800 text-center border-r border-gray-200">
                {item?.material_type?.name || '-'}
              </td>
              <td className="px-4 py-2 text-sm text-gray-800 text-center border-r border-gray-200">
                {isGoldBar
                  ? item?.weight > 0
                    ? item?.weight.toLocaleString(undefined, {
                        minimumFractionDigits: 3,
                        maximumFractionDigits: 3,
                      })
                    : '0.000'
                  : item?.weight > 0
                  ? item?.weight.toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })
                  : '0.00'}
                {/* {!isOtherPlace
                  ? item?.weight > 0
                    ? item?.weight.toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })
                    : '0.00'
                  : item?.inventory > 0
                  ? item?.inventory.toLocaleString(undefined, {
                      minimumFractionDigits: 0,
                      maximumFractionDigits: 0,
                    })
                  : '0'} */}
              </td>
              <td className="px-4 py-2 text-sm text-gray-800 text-center border-r border-gray-200">
                {avgValue2f > 0
                  ? avgValue2f.toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })
                  : '0.00'}
              </td>
              <td className="px-4 py-2 text-sm text-gray-800 text-center">
                {isNaN(averageProfit) === false
                  ? averageProfit.toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })
                  : '0.00'}
              </td>
            </tr>
          );
        })
      ) : (
        <tr>
          <td colSpan="6" className="text-center py-6 text-gray-500">
            ไม่มีข้อมูล
          </td>
        </tr>
      )}
    </tbody>
  );

  const TableFooter = (place) => (
    <thead className="bg-yellow-100">
      <tr>
        <th className="px-4 py-3 text-left text-sm font-bold text-gray-800 border-r border-gray-300">
          รวมกำไรขั้นต้นทั้งหมด
        </th>
        <th className="px-4 py-3 text-center text-sm font-bold text-gray-800 border-r border-gray-300"></th>

        <th className="px-4 py-3 text-center text-sm font-bold text-gray-800 border-r border-gray-300"></th>

        <th className="px-4 py-3 text-center text-sm font-bold text-gray-800 border-r border-gray-300"></th>
        <th className="px-4 py-3 text-center text-sm font-bold text-gray-800">
          {place.place === 'คลังรูปพรรณใหม่'
            ? totalProfitNew.toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })
            : place.place === 'คลังรูปพรรณเก่า'
            ? totalProfitOld.toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })
            : totalProfitOther.toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
        </th>
      </tr>
    </thead>
  );

  // ส่วนของการ Render หลักยังคงใช้ data.material.rows ซึ่งโครงสร้างถูกต้องอยู่แล้ว
  return (
    <div className="space-y-6">
      {_.isArray(data?.material?.rows) && data.material.rows.length > 0 ? (
        _.chain(data.material.rows)
          .groupBy('place.name')
          .toPairs()
          .sortBy(([placeName]) =>
            placeName === 'คลังรูปพรรณใหม่' ? '0' : `1_${placeName || 'zzz'}`,
          )
          .map(([placeName, materials]) => {
            const sortedMaterials = _.sortBy(materials, (item) => {
              const materialTypeName = item?.material_type?.name || '';
              return materialTypeName === '96.5%'
                ? '0'
                : `1_${materialTypeName}`;
            });

            return (
              <div
                key={placeName}
                className="bg-white rounded-lg shadow-sm overflow-hidden"
              >
                <div className="bg-gray-50 px-4 py-2 border-b">
                  <h3 className="text-lg font-semibold text-gray-800">
                    {placeName || 'ไม่ระบุคลัง'}
                  </h3>
                </div>
                <div className="overflow-x-auto">
                  <table className="w-full">
                    <TableHeader place={placeName} />
                    <TableRows materials={sortedMaterials} />
                    <TableFooter place={placeName} />
                  </table>
                </div>
              </div>
            );
          })
          .value()
      ) : (
        <div className="bg-white rounded-lg shadow-sm overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full">
              <TableHeader />
              <TableRows materials={[]} />
            </table>
          </div>
        </div>
      )}
    </div>
  );
};

export default BalanceStockTable;
